<template>
    <div class="mb-3 col-sm-12 col-md-6 col-lg-3" :class="[shortlistClass]">
        <div class="text-md-left text-center" :class="[buttonAlignmentClass]">
            <audio :ref="audioId" preload="none" v-on:ended="audioEnded">
                <source :src="sampleUrl"/>
            </audio>
            <!-- <span class="lead btn-sound" :class="[buttonClass, colorClass]" v-on:click="togglePlayback"><i class="fas mr-2" :class="[buttonIconClass]"></i>{{ soundName }}</span> -->

            <div class="btn-group">
                <button type="button" class="lead btn-sound" :class="[buttonClass, colorClass]" v-on:click="togglePlayback"><i class="fas mr-2" :class="[buttonIconClass]"></i>{{ soundName }}</button>
                <template v-if="platform === 'all'">
                    <button type="button" class="btn btn-sound dropdown-toggle dropdown-toggle-split" :class="[buttonClass, colorClass]" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" :href="quickLinkUrl('alexa')" target="_blank" :title="quickLinkTitle('alexa')">{{ quickLinkTitle('alexa') }}</a>
                    </div>
                </template>
                <template v-else-if="showQuickLink">
                    <a type="button" class="lead btn-sound btn btn-sm btn-outline-light color-white" :href="quickLinkUrl()" target="_blank" :title="quickLinkTitle()"><i :class="quickLinkIconClass()"></i></a>
                </template>
                <template v-else-if="showDetailLink">
                    <a type="button" class="lead btn-sound btn btn-sm btn-light" :href="deepLink" :title="item.name"><i class="fa fa-arrow-right"></i></a>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '../event-bus.js';
    export default {
        props: ['emitConfig','buttonAlignment','item','index','itemKey','isShortlist','platform', 'type', 'subtype', 'isShortName','showDetailLink'],
        data () {
            return {
                "is_playing": false
            }
        },
        methods: {
            quickLinkTitle: function(platformOverride){
                platformOverride = platformOverride || this.platform;
                switch(platformOverride){
                    case "aog":
                        return "Send this sound to Google Assistant";
                    case "alexa":
                        if(this.type == "alarm"){
                            return "Enable this alarm tone on Alexa";
                        }else{
                            return "Send this sound to Alexa";
                        }
                    case "bixby":
                        return "Send this sound to Bixby";
                    default:
                        return "";
                }
            },
            quickLinkUrl: function(platformOverride){
                platformOverride = platformOverride || this.platform;
                switch(platformOverride){
                    case "aog":
                        return "https://assistant.google.com/services/invoke/uid/000000695a2a1b21?intent=Sound%20Selected&param.Sound=" + this.shortSoundName + "&hl=en";
                    case "alexa":
                        if(this.type == "alarm"){
                            return this.item.alexa_alarm_url;
                        }else{
                            return this.$root.quick_launch.alexa + "&sound=" + this.shortSoundName;
                        }
                    default:
                        return "";
                }
            },
            quickLinkIconClass: function(platformOverride){
                platformOverride = platformOverride || this.platform;
                switch(platformOverride){
                    case "aog":
                        return {
                            "fab": true,
                            "fa-google": true
                        };
                    case "alexa":
                        return {
                            "fab": true,
                            "fa-amazon": true
                        };
                    default:
                        return {};
                }
            },
            "stopAudio": function(){
                this.is_playing = false;
                this.$refs[this.audioId].pause();
                this.$root.removePlaying(this.emitConfig.pool, this.itemKey);
            },
            "startAudio": function(){
                this.is_playing = true;
                this.$refs[this.audioId].currentTime = 0;
                this.$refs[this.audioId].play();
                this.$root.addPlaying(this.emitConfig.pool, this.itemKey);

                // if more than 2 sounds are playing, force the first to stop
                if(this.$root.now_playing[this.emitConfig.pool].length > 1){
                    console.log("more than 2 playing");
                    console.log(this.$root.now_playing[this.emitConfig.pool][0]);
                    EventBus.$emit(this.emitConfig.emitter, this.$root.now_playing[this.emitConfig.pool][0]);
                }
            },
            "audioEnded": function(){
                this.stopAudio();
            },
            "togglePlayback": function(){
                if(this.is_playing){
                    // stop it
                    this.stopAudio();
                }else{
                    // start it
                    this.startAudio();
                }
            }
        },
        computed: {
            soundName: function(){
                if(this.isShortName === true){
                    return this.shortSoundName;
                }else{
                    return this.item.name;
                }
            },
            shortSoundName: function(){
                return this.item.name.replace(" Sounds", "");
            },
            iconStyle: function(){
                return "background: #fff url('/images/app-icons/150/" + this.itemKey + ".png') center/cover no-repeat;";
            },
            audioId: function(){
                return "audio" + this.itemKey;
            },
            sampleUrl: function(){
                if(this.type == "alarm" && this.subtype == "premium"){
                    return "/audio/hd/alarms/" + this.itemKey + ".mp3";
                }

                var filename = this.itemKey;
                if(this.item.variants.length){
                    filename = this.item.variants.find(function(variant){
                        return variant.is_default;
                    }).key;
                }
                return "/audio/sd/sample/" + filename + ".mp3";
            },
            deepLink: function(){
                var url = "";
                switch(this.item.type){
                    case "STORY":
                        url += "/stories";
                        break;
                    case "MEDITATION":
                        url += "/meditations";
                        break;
                    case "JOURNEY":
                        url += "/journeys";
                        break;
                    default:
                        url += "/sounds";
                }
                url += `/${this.itemKey}`;

                return url;
            },
            showQuickLink: function(){
                if(this.type == "alarm" && this.subtype == "premium"){
                    return false;
                }

                switch(this.platform){
                    case "all":
                    case "aog":
                    case "alexa":
                        return true;
                    default:
                        return false;
                }
            },
            buttonAlignmentClass: function(){
                return {
                    "text-md-left": this.buttonAlignment != "center" ? true : false,
                    "text-md-center": this.buttonAlignment == "center" ? true : false
                };
            },
            buttonClass: function(){
                return {
                    "btn": true,
                    "btn-sm": true,
                    "btn-outline-light": !this.is_playing,
                    "btn-light": this.is_playing
                };
            },
            buttonIconClass: function(){
                return {
                    "fa-play": !this.is_playing,
                    "fa-stop": this.is_playing
                };
            },
            colorClass: function(){
                return {
                    "color-white": !this.is_playing,
                    "color-purple": this.is_playing
                };
            },
            buttonText: function(){
                return this.is_playing ? "Stop" : "Preview";
            },
            shortlistClass: function(){
                return {
                    "sound-container": this.isShortlist ? true : false
                }
            }
        }
    }
</script>
